// Plain async helpers for customer API calls.
//
// These are thin wrappers over apiClient for use in contexts where a React hook
// (useMutation) is not appropriate — e.g. called imperatively inside another
// hook's submit flow. React hook-based variants live in
// clients/web/src/pages/customers/hooks/useCustomerMutations.ts.

import { apiClient } from './client';
import { endpoints } from './endpoints';
import type { CustomerSummary } from '../types/api';

export interface CreateCustomerPayload {
  name: string;
  phone?: string | null;
  email?: string | null;
  phone2?: string | null;
  address?: string | null;
  postcode?: string | null;
}

/**
 * Creates a new customer record and returns the created CustomerSummary.
 *
 * The server responds with `{ success, data: { customer: CustomerSummary } }`.
 * apiClient.post already unwraps the outer axios response to `ApiSuccess<T>`,
 * so we access `.data.customer` on the resolved value.
 */
export async function createCustomer(
  input: CreateCustomerPayload,
): Promise<CustomerSummary> {
  const res = await apiClient.post<{ customer: CustomerSummary }>(
    endpoints.customers.create,
    input,
  );
  return res.data.customer;
}
